import route from "@/router";
import store from "@/store/store";
import { DO_LOGOUT } from "@/store/actions";
import { message } from "ant-design-vue";

export const success = (response) => {  
    return response;
}

export const error = (res) => {
    if (res.response.status === 401 || res.response.status === 400) {
        store.dispatch(DO_LOGOUT);        
        route.push({ name: 'login', params: { error: "Sessão expirou" } });
        return { data: { statusCode: 200, ...res.response.data } };
    } else if (res.response.status === 429)
    {
        return { data: { statusCode: 429, errorMessage: 'Muitas requisições. Tente novamente mais tarde.' } };
    }
    return res;
}
